import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Layout, PrimaryButton } from '../components'
import { signIn } from '../reducks/users/operations'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// mui
import TextField from '@material-ui/core/TextField'

const SignIn = () => {
    const dispatch = useDispatch()

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const inputEmail = useCallback( event => {
        setEmail(event.target.value)
    }, [setEmail]);
    const inputPassword = useCallback( event => {
        setPassword(event.target.value)
    }, [setPassword]);

    return (
        <Layout>
            <div className='spacer-100'></div>
            <h1 style={{textAlign:'center'}}>ログイン</h1>
            <div className='spacer-50'></div>
            <InputWrapper>
                <TextField 
                    fullWidth={true} label={'メールアドレス'} multiline={false} required={true} variant="filled"
                    rows={1} value={email} type={'email'} onChange={inputEmail} style={{marginBottom: '10px'}}
                />
                <TextField 
                    fullWidth={true} label={'パスワード'} multiline={false} required={true} variant="filled"
                    rows={1} value={password} type={'password'} onChange={inputPassword}
                />
            </InputWrapper>
            <div className='spacer-50' />
            <div style={{textAlign:'center'}}>
                <PrimaryButton label={"ログイン"} operation={ () => dispatch(signIn(email,password)) } />
                <div className='spacer-50' />
                <p onClick={()=>dispatch(push('/signup'))}>アカウントをお持ちでない方はこちら</p>
                <br/>
                <p onClick={()=>dispatch(push('/signin/reset'))}>パスワードをお忘れの方はこちら</p>
            </div>
            <div className='spacer-100' />
        </Layout>
    )
}
export default SignIn

const InputWrapper = styled.div`
    width: 320px;
    margin: 0 auto;
`